import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcTwoMan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 29,
	viewBox: "0 0 28 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9.5,
			r: 4,
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 9.5,
			r: 4,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 17.5C2 15.8431 3.34315 14.5 5 14.5H13C14.6569 14.5 16 15.8431 16 17.5V22.5C16 23.0523 15.5523 23.5 15 23.5H3C2.44772 23.5 2 23.0523 2 22.5V17.5Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 17.5C12 15.8431 13.3431 14.5 15 14.5H23C24.6569 14.5 26 15.8431 26 17.5V22.5C26 23.0523 25.5523 23.5 25 23.5H13C12.4477 23.5 12 23.0523 12 22.5V17.5Z",
			fill: "#6C9CFA"
		})
	]
});
export default SvgIcTwoMan;
